export default __webpack_public_path__ + "static/media/36I-102745_-15831_0.4c50dbda.jpg";